import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex w-full justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "text-white text-xxs my-auto min-w-fit"
}

import {PropType} from "vue";
import UserVerificationCheck from "@/components/UserBadges.vue";
import {ChatParticipantInterface} from "@/interfaces/ChatParticipantInterface";
import UserListItem from "@/components/UserListItem.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'ChatParticipant',
  props: {
    user: {
        type: Object as PropType<ChatParticipantInterface>,
        required: true
    }
},
  setup(__props) {


const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UserListItem, { user: __props.user }, null, 8, ["user"]),
    (__props.user.role === 'ADMIN')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " GROUP ADMIN "))
      : _createCommentVNode("", true)
  ]))
}
}

})